import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  name: 'MemberCommentList',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      rules: {
        passWord: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        rePassWord: [{
          required: true,
          message: '请输入确认密码',
          trigger: 'blur'
        }]
      },
      title: '修改密码',
      form: {
        passWord: null,
        rePassWord: null
      }
    };
  },
  methods: {
    handleClose: function handleClose(done) {
      this.$emit('close');
    },
    updatePassWord: function updatePassWord(password, rePassWord) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                passWord: password,
                rePassWord: rePassWord
              };
              _context.n = 1;
              return api.UPDATE_USER_PASSWORD(par);
            case 1:
              _this.form.passWord = null;
              _this.form.rePassWord = null;
              _this.$message.success('密码已变更');
              _this.handleClose(11);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    update: function update() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this2.updatePassWord(_this2.form.passWord, _this2.form.rePassWord);
          }).catch(function () {
            _this2.$message({
              type: 'info',
              message: '已取消修改'
            });
          });
        } else {
          return false;
        }
      });
    }
  }
};